import React from 'react'
import PageContainerDesktop from 'components/PageContainer/layout/PageContainer.desktop'
import { useRouteMatch } from 'react-router'
import { Route, Switch } from 'react-router-dom'
import { SubPrivateRoute } from 'routes/PrivateRoute'
import { sppSubRoutes } from 'routes/desktopRoutes'
import { SppTabs } from './components/SppTabs/SppTabs'

const HomeSppDesktop = () => {
  const { path } = useRouteMatch()

  return (
    <Switch>
      <Route exact path={path}>
        <PageContainerDesktop>
          <SppTabs />
        </PageContainerDesktop>
      </Route>
      {sppSubRoutes.map(route => (
        <SubPrivateRoute {...route} key={route.path} />
      ))}
    </Switch>
  )
}
export default HomeSppDesktop
